var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "content-header" }, [
    _c("div", { staticClass: "shadow-layout" }, [
      _c("div", { staticClass: "position-absolute box-layout" }, [
        _c("div", { staticClass: "box-load" }, [
          _c("div", { staticClass: "loader", attrs: { id: "loading" } }),
          _vm._v(" "),
          _c("div", { staticClass: "text-load" }, [
            _c("span", [_vm._v("Loading")]),
            _vm._v(" "),
            _vm.isUploading
              ? _c("span", { staticClass: "text-load-sub" }, [
                  _vm._v(
                    "\n                        " +
                      _vm._s(_vm.$t("general.upload_takes_time")) +
                      "\n                    "
                  )
                ])
              : _vm._e()
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-14fac4dc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-14fac4dc","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/common/Loading.vue
// module id = null
// module chunks = 